import React from "react";
import { Query } from "react-apollo";
import ScreenLoading from "../LoadingScreen.jsx";
import { ApolloConsumer } from "react-apollo";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// File imports
import AllEmployerList from "./AllEmployerList.jsx";
import DataNotFound from "../DataNotFound";
import Errorpage from "../Pages/errorPage";
// Queries and mutation
import ListAllEmployerQuery from "../../Graphql/Querries/ListAllEmployerQuery";

//Employment query
const Myemployeequery = ({
	username = localStorage.getItem("username"),
	history,
	client,
	status
}) => (
	<Query query={ListAllEmployerQuery} variables={{ username }}>
		{({ loading, data, error }) => {
			if (loading) {
				return (
					<GridContainer justify="center">
						<GridItem xs={10} sm={8} md={8}>
							<ScreenLoading />
						</GridItem>
					</GridContainer>
				);
			}
			if (error) {
				return (
					<div>
						<Errorpage />
					</div>
				);
			}
			return (
				<div>
					{data.getAllEmployees === null ? (
						<DataNotFound
							message={"There Is No Authority Onboarded Into VerifyMate Yet"}
							backbutton={false}
						/>
					) : (
						<AllEmployerList
							key={data.getAllEmployers}
							AllEmployersList={data.getAllEmployers}
							history={history}
							client={client}
							status={status}
						/>
					)}
				</div>
			);
		}}
	</Query>
);

class MyAllEmployee extends React.Component {
	render() {
		return (
			<ApolloConsumer>
				{client => (
					<Myemployeequery
						history={this.props.history}
						client={client}
						status={this.props.location.state}
					/>
				)}
			</ApolloConsumer>
		);
	}
}

export default MyAllEmployee;
